// /* eslint-disable*/
// import React, { useEffect, useState } from "react";
// import { Doughnut, Bar } from "react-chartjs-2";
// import {
//   Chart,
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   LineElement,
//   PointElement
// } from "chart.js";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faPlus,
//   faChevronLeft,
//   faChevronRight,
//   faRefresh,
//   faSearch,
//   faSortUp,
//   faSortDown,
//   faSort,
//   faL,
//   faDownload,
//   faShare,
// } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";
// import { API_URL } from "../config.js";
// import LoadingSpinner from "../components/LoadingSpinner.jsx";
// import html2canvas from "html2canvas";

// Chart.register(
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   LineElement,
//   PointElement
// );

// const ServiceReport = ({ serviceId }) => {
//   const [reportData, setReportData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const fetchServiceReport = async () => {
//     try {
//       setLoading(true);
//       const token = localStorage.getItem("authToken");
//       const response = await axios.get(
//         `${API_URL}dashboard/service-report/${serviceId}`,
//         { headers: { Authorization: `Bearer ${token}`, Accept: "*/*" } }
//       );
//       setReportData(response.data);
//     } catch (err) {
//       console.error(err);
//       setError("Failed to load service report");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchServiceReport();
//   }, [serviceId]);

//   if (loading) return <LoadingSpinner />;
//   if (error) return <p className="text-danger">{error}</p>;
//   if (!reportData) return null;

//   const {
//     services,
//     chartimgs,
//     totalcount50,
//     positivecount50,
//     negativecount50,
//     totalprofit50,
//     totalloss50,
//     avgprofit50,
//     accuracy50,
//     profitvalue50,
//     lossvalue50,
//     totalcount500,
//     positivecount500,
//     negativecount500,
//     totalprofit500,
//     totalloss500,
//     avgprofit500,
//     accuracy500,
//     profitvalue500,
//     lossvalue500,
//     performance,
//     datewise
//   } = reportData;

//   // Doughnut Chart Data for Last 50 Trades
//   const doughnutData50 = {
//     labels: ["Profit", "Loss"],
//     datasets: [
//       {
//         data: [profitvalue50, lossvalue50],
//         backgroundColor: ["#6fca00", "#e03e25"],
//         borderWidth: 0,
//       },
//     ],
//   };

//   // Doughnut Chart Data for Last 500 Trades
//   const doughnutData500 = {
//     labels: ["Profit", "Loss"],
//     datasets: [
//       {
//         data: [profitvalue500, lossvalue500],
//         backgroundColor: ["#6fca00", "#e03e25"],
//         borderWidth: 0,
//       },
//     ],
//   };

//   const downloadChart50 = () => {
//     const chartElement = document.getElementById("chart50-container");
//     if (!chartElement) return;

//     html2canvas(chartElement, {
//       scale: 2,
//       backgroundColor: "#ffffff",
//       useCORS: true
//     }).then((canvas) => {
//       const ctx = canvas.getContext("2d");

//       // Create a larger canvas to accommodate title and disclaimer
//       const finalCanvas = document.createElement('canvas');
//       finalCanvas.width = canvas.width;
//       finalCanvas.height = canvas.height + 160; // Extra space for title and disclaimer
//       const finalCtx = finalCanvas.getContext("2d");

//       // Fill background
//       finalCtx.fillStyle = "#ffffff";
//       finalCtx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);

//       // Add title
//       finalCtx.fillStyle = "#000000";
//       finalCtx.font = "bold 36px Arial";
//       finalCtx.textAlign = "center";
//       finalCtx.fillText("Last 50 Trades Summary", finalCanvas.width / 2, 50);

//       // Add main content (original canvas)
//       finalCtx.drawImage(canvas, 0, 80);

//       // Add disclaimer
//       finalCtx.fillStyle = "#666666";
//       finalCtx.font = "14px Arial";
//       finalCtx.textAlign = "center"; // center align for full width
//       const disclaimer = [
//         "Disclaimer: The performance data shows the Research Results generated by our recommendations.",
//         "Past performance doesn't guarantee future success. Investing in the securities market involves market risks.",
//         "The securities mentioned do not constitute a recommendation. The returns displayed are for informational purposes",
//         "only and should not be considered advertisements or promotions influencing your subscription decisions."
//       ];

//       const maxWidth = finalCanvas.width - 80; // leave some padding
//       const lineHeight = 18;
//       const startY = canvas.height + 80;

//       disclaimer.forEach((line, index) => {
//         wrapText(finalCtx, line, finalCanvas.width / 2, startY + index * lineHeight, maxWidth, lineHeight);
//       });

//       // Helper function to wrap text
//       function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
//         const words = text.split(" ");
//         let line = "";
//         let lineCount = 0;

//         for (let n = 0; n < words.length; n++) {
//           const testLine = line + words[n] + " ";
//           const metrics = ctx.measureText(testLine);
//           const testWidth = metrics.width;
//           if (testWidth > maxWidth && n > 0) {
//             ctx.fillText(line, x, y + lineCount * lineHeight);
//             line = words[n] + " ";
//             lineCount++;
//           } else {
//             line = testLine;
//           }
//         }
//         ctx.fillText(line, x, y + lineCount * lineHeight);
//       }

//       const link = document.createElement("a");
//       link.download = "Last-50-Trades-Summary.png";
//       link.href = finalCanvas.toDataURL("image/png");
//       link.click();
//     });
//   };

//   const downloadChart500 = () => {
//     const chartElement = document.getElementById("chart500-container");
//     if (!chartElement) return;

//     html2canvas(chartElement, {
//       scale: 2,
//       backgroundColor: "#ffffff",
//       useCORS: true
//     }).then((canvas) => {
//       const ctx = canvas.getContext("2d");

//       // Create a larger canvas to accommodate title and disclaimer
//       const finalCanvas = document.createElement('canvas');
//       finalCanvas.width = canvas.width;
//       finalCanvas.height = canvas.height + 160; // Extra space for title and disclaimer
//       const finalCtx = finalCanvas.getContext("2d");

//       // Fill background
//       finalCtx.fillStyle = "#ffffff";
//       finalCtx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);

//       // Add title
//       finalCtx.fillStyle = "#000000";
//       finalCtx.font = "bold 36px Arial";
//       finalCtx.textAlign = "center";
//       finalCtx.fillText("Last 500 Trades Summary", finalCanvas.width / 2, 50);

//       // Add main content (original canvas)
//       finalCtx.drawImage(canvas, 0, 80);

//       // Add disclaimer (wrapped text)
//       finalCtx.fillStyle = "#666666";
//       finalCtx.font = "14px Arial";
//       finalCtx.textAlign = "center"; // center align for full width
//       const disclaimer = [
//         "Disclaimer: The performance data shows the Research Results generated by our recommendations.",
//         "Past performance doesn't guarantee future success. Investing in the securities market involves market risks.",
//         "The securities mentioned do not constitute a recommendation. The returns displayed are for informational purposes",
//         "only and should not be considered advertisements or promotions influencing your subscription decisions."
//       ];

//       const maxWidth = finalCanvas.width - 80; // padding from sides
//       const lineHeight = 18;
//       const startY = canvas.height + 100;

//       disclaimer.forEach((line, index) => {
//         wrapText(finalCtx, line, finalCanvas.width / 2, startY + index * lineHeight, maxWidth, lineHeight);
//       });

//       // Helper function to wrap text
//       function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
//         const words = text.split(" ");
//         let line = "";
//         let lineCount = 0;

//         for (let n = 0; n < words.length; n++) {
//           const testLine = line + words[n] + " ";
//           const metrics = ctx.measureText(testLine);
//           const testWidth = metrics.width;
//           if (testWidth > maxWidth && n > 0) {
//             ctx.fillText(line, x, y + lineCount * lineHeight);
//             line = words[n] + " ";
//             lineCount++;
//           } else {
//             line = testLine;
//           }
//         }
//         ctx.fillText(line, x, y + lineCount * lineHeight);
//       }

//       // Download final image
//       const link = document.createElement("a");
//       link.download = "Last-500-Trades-Summary.png";
//       link.href = finalCanvas.toDataURL("image/png");
//       link.click();
//     });
//   };

//   const doughnutOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     cutout: "75%",
//     plugins: {
//       legend: {
//         display: false
//       },
//       tooltip: {
//         enabled: false
//       }
//     }
//   };

//   // Performance Chart Data (Last 12 months)
//   const performanceChartData = {
//     labels: performance.map(p => {
//       const date = new Date(p.month);
//       return date.toLocaleDateString('en-US', { month: 'short', year: '2-digit' });
//     }).reverse(),
//     datasets: [
//       {
//         label: "Last 12 months Performance",
//         data: performance.map(p => p.total_gains).reverse(),
//         backgroundColor: "#127BBC",
//         borderColor: "#127BBC",
//         borderWidth: 1.5,
//         pointBackgroundColor: "#FFFFFF",
//         pointBorderWidth: 1.5,
//         pointRadius: 4,
//         pointHoverBackgroundColor: "#127BBC",
//         pointHoverBorderColor: "#FFFFFF",
//         pointHoverRadius: 7,
//       }
//     ]
//   };

//   // Recent Trades Chart Data
//   const recentTradesData = {
//     labels: datewise.map(d => {
//       const date = new Date(d.date);
//       return date.toLocaleDateString('en-US', { day: '2-digit', month: '2-digit' });
//     }).reverse(),
//     datasets: [
//       {
//         label: "Recent Trades Advisories Report",
//         data: datewise.map(d => d.total_gains).reverse(),
//         backgroundColor: "#127BBC",
//         borderColor: "#127BBC",
//         borderWidth: 1.5,
//         pointBackgroundColor: "#FFFFFF",
//         pointBorderWidth: 1.5,
//         pointRadius: 4,
//         pointHoverBackgroundColor: "#127BBC",
//         pointHoverBorderColor: "#FFFFFF",
//         pointHoverRadius: 7,
//       }
//     ]
//   };

//   const barChartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     scales: {
//       y: {
//         beginAtZero: true,
//         ticks: {
//           callback: function (value) {
//             return '₹' + value;
//           }
//         }
//       }
//     },
//     plugins: {
//       legend: {
//         display: true,
//         position: 'top'
//       },
//       tooltip: {
//         callbacks: {
//           label: function (context) {
//             return 'Gains : ₹' + context.parsed.y;
//           }
//         }
//       }
//     }
//   };

//   // Doughnut with center text component
//   const DoughnutWithCenter = ({ data, profitValue }) => (
//     <div style={{ position: 'relative', width: '140px', height: '140px', margin: '0 auto', marginLeft: '0px' }}>
//       <Doughnut data={data} options={doughnutOptions} />
//       <div style={{
//         position: 'absolute',
//         top: '50%',
//         left: '50%',
//         transform: 'translate(-50%, -50%)',
//         textAlign: 'center',
//         pointerEvents: 'none'
//       }}>
//         <div style={{ fontSize: '14px', color: '#9ca3af', fontWeight: '500' }}>Profit</div>
//         <div style={{ fontSize: '18px', color: '#3f4b6b', fontWeight: '700', marginTop: '4px' }}>₹{profitValue}</div>
//       </div>
//     </div>
//   );

//   // Accuracy circle component
//   const AccuracyCircle = ({ accuracy }) => {
//     const size = 140;
//     const strokeWidth = 12;
//     const radius = (size - strokeWidth) / 2;
//     const circumference = 2 * Math.PI * radius;
//     const offset = circumference - (accuracy / 100) * circumference;

//     return (
//       <svg width={size} height={size}>
//         <circle
//           stroke="#e0e0e0"
//           fill="transparent"
//           strokeWidth={strokeWidth}
//           r={radius}
//           cx={size / 2}
//           cy={size / 2}
//         />
//         <circle
//           stroke="#6fca00"
//           fill="transparent"
//           strokeWidth={strokeWidth}
//           r={radius}
//           cx={size / 2}
//           cy={size / 2}
//           strokeDasharray={circumference}
//           strokeDashoffset={offset}
//           strokeLinecap="round"
//           style={{ transition: 'stroke-dashoffset 1s' }}
//         />
//         <text x="50%" y="45%" textAnchor="middle" fontSize="12" fill="#000">Accuracy</text>
//         <text x="50%" y="60%" textAnchor="middle" fontSize="20" fontWeight="bold" fill="#000">{accuracy}%</text>
//       </svg>
//     );
//   };

//   // Summary Box Component
//   const SummaryBox = ({ data }) => {
//     const { totalCalls, totalProfit, profitCalls, totalLoss, lossCalls, netProfit } = data;
//     return (
//       <div className="summarylist">
//         <div className="summary-row">
//           <div className="summary-item">✓ Total Calls : <span className="blue-text">{totalCalls}</span></div>
//           <div className="summary-item">✓ Total Profit : <span className="green-text">₹ {totalProfit}</span></div>
//         </div>
//         <div className="summary-row">
//           <div className="summary-item">✓ Profitable Calls : <span className="green-text">{profitCalls}</span></div>
//           <div className="summary-item">✓ Total Loss : <span className="red-text">₹ {totalLoss}</span></div>
//         </div>
//         <div className="summary-row">
//           <div className="summary-item">✓ Loss Calls : <span className="red-text">{lossCalls}</span></div>
//           <div className="summary-item">✓ Net Profit : <span className="green-text">₹ {netProfit}</span></div>
//         </div>
//       </div>
//     );
//   };

//   // Prepare data for summary boxes
//   const tradeData50 = {
//     totalCalls: totalcount50,
//     profitCalls: positivecount50,
//     lossCalls: negativecount50,
//     totalProfit: totalprofit50,
//     totalLoss: totalloss50,
//     netProfit: avgprofit50
//   };

//   const tradeData500 = {
//     totalCalls: totalcount500,
//     profitCalls: positivecount500,
//     lossCalls: negativecount500,
//     totalProfit: totalprofit500,
//     totalLoss: totalloss500,
//     netProfit: avgprofit500
//   };

//   return (
//     <div id="content" className="">
//       {/* Page Header */}
//       <h1 className="page-header">
//         Dashboard <small> Analysis</small>
//       </h1>

//       <div className="row">
//         {/* Recent Report Chart */}
//         <div className="col-md-12">
//           <div className="panel panel-default with-rounded-corner with-shadow chartbox">
//             <div className="panel-heading">
//               <h6 className="panel-title">Recent Report</h6>
//             </div>
//             <div className="panel-body">
//               <div className="box">
//                 <Bar data={recentTradesData} options={barChartOptions} height={550} />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* New Design for Last 50 Trades Summary */}
//         <div className="col-md-6">
//           <div className="panel panel-default with-rounded-corner with-shadow chartbox">
//             <div className="panel-heading">
//               <h6 className="panel-title">
//                 Last 50 Trades Summary
//                 <span className="float-right">
//                   {chartimgs && chartimgs[50] && (
//                     <>
//                       <a className="genlinkclass" onClick={downloadChart50}>
//                         <FontAwesomeIcon icon={faDownload} />
//                       </a>

//                       <a className="genlinkclass" href={`${API_URL}dashboard/genServiceReport/${serviceId}/50`}>
//                         <FontAwesomeIcon icon={faShare} />
//                       </a>
//                     </>
//                   )}
//                 </span>
//               </h6>
//             </div>
//             <div className="panel-body">
//               <div className="trade-panel-new" id="chart50-container">
//                 <div className="charts-row">
//                   <DoughnutWithCenter data={doughnutData50} profitValue={totalprofit50} />
//                   <AccuracyCircle accuracy={accuracy50} />
//                 </div>
//                 <SummaryBox data={tradeData50} />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* New Design for Last 500 Trades Summary */}
//         <div className="col-md-6">
//           <div className="panel panel-default with-rounded-corner with-shadow chartbox">
//             <div className="panel-heading">
//               <h6 className="panel-title">
//                 Last 500 Trades Summary
//                 <span className="float-right">
//                   {chartimgs && chartimgs[500] && (
//                     <>
//                       <a className="genlinkclass" onClick={downloadChart500}>
//                         <FontAwesomeIcon icon={faDownload} />
//                       </a>
//                       <a className="genlinkclass" href={`${API_URL}dashboard/genServiceReport/${serviceId}/500`}>
//                         <FontAwesomeIcon icon={faShare} />
//                       </a>
//                     </>
//                   )}
//                 </span>
//               </h6>
//             </div>
//             <div className="panel-body">
//               <div className="trade-panel-new" id="chart500-container">
//                 <div className="charts-row">
//                   <DoughnutWithCenter data={doughnutData500} profitValue={totalprofit500} />
//                   <AccuracyCircle accuracy={accuracy500} />
//                 </div>
//                 <SummaryBox data={tradeData500} />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Performance By Services */}
//         <div className="col-md-12">
//           <div className="panel panel-default with-rounded-corner with-shadow">
//             <div className="panel-heading">
//               <h4 className="panel-title">Performance By Services</h4>
//             </div>
//             <div className="panel-body">
//               <Bar data={performanceChartData} options={barChartOptions} height={50} />
//             </div>
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         .content {
//           padding: 20px;
//         }
//         .page-header {
//           margin: 0 0 20px;
//           padding: 0;
//           border: none;
//           font-size: 24px;
//         }
//         .page-header small {
//           color: #6c757d;
//           font-size: 16px;
//         }
//         .panel {
//           margin-bottom: 30px;
//           background: #fff;
//           border: none;
//           border-radius: 8px;
//         }
//         .panel-default.with-rounded-corner.with-shadow {
//           border-radius: 8px;
//           box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.2);
//           border: none;
//         }
//         .chartbox {
//           padding: 20px 15px;
//           margin-bottom: 30px;
//         }
//         .panel-heading {
//           background: #fff;
//           border-bottom: 1px solid rgba(83, 91, 98, 0.25);
//           padding: 15px 20px;
//           border-radius: 8px 8px 0 0;
//         }
//         .panel-title {
//           margin: 0;
//           font-size: 16px;
//           font-weight: 600;
//           color: #333;
//         }
//         .panel-body {
//           padding: 20px;
//         }

//         /* New Trade Panel Styles */
//         .trade-panel-new {
//           text-align: center;
//         }
//         .charts-row {
//           display: flex;
//           justify-content: space-around;
//           align-items: center;
//           margin-bottom: 20px;
//         }
//         .summarylist {
//           text-align: left;
//         }
//         .summary-row {
//           display: flex;
//           justify-content: space-between;
//           margin-bottom: 10px;
//         }
//         .summary-item {
//           font-size: 14px;
//           display: flex;
//           align-items: center;
//         }
//         .blue-text {
//           color: #127BBC;
//           font-weight: 600;
//           margin-left: 4px;
//         }
//         .green-text {
//           color: #6fca00;
//           font-weight: 600;
//           margin-left: 4px;
//         }
//         .red-text {
//           color: #e03e25;
//           font-weight: 600;
//           margin-left: 4px;
//         }

//         .genlinkclass {
//           padding: 5px 10px;
//           font-size: 15px;
//           color: #000;
//           text-decoration: none !important;
//           margin-left: 10px;
//           cursor: pointer;
//         }
//         .genlinkclass:hover {
//           color: #127BBC;
//         }
//         .float-right {
//           float: right;
//         }
//         #chart50-container, #chart500-container {
//           background: #ffffff !important;
//           padding: 40px;
//           border-radius: 12px;
//         }

//         @media (max-width: 768px) {
//           .charts-row {
//             flex-direction: column;
//             gap: 20px;
//           }
//           .summary-row {
//             flex-direction: column;
//             gap: 8px;
//           }
//           .summary-item {
//             justify-content: space-between;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default ServiceReport;


/* eslint-disable*/
import React, { useEffect, useState } from "react";
import { Doughnut, Bar } from "react-chartjs-2";
import {
  Chart,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  LineElement,
  PointElement
} from "chart.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faChevronLeft,
  faChevronRight,
  faRefresh,
  faSearch,
  faSortUp,
  faSortDown,
  faSort,
  faL,
  faDownload,
  faShare,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { API_URL } from "../config.js";
import LoadingSpinner from "../components/LoadingSpinner.jsx";
import html2canvas from "html2canvas";

Chart.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  LineElement,
  PointElement
);

const ServiceReport = ({ serviceId }) => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchServiceReport = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");
      const response = await axios.get(
        `${API_URL}dashboard/service-report/${serviceId}`,
        { headers: { Authorization: `Bearer ${token}`, Accept: "*/*" } }
      );
      setReportData(response.data);
    } catch (err) {
      console.error(err);
      setError("Failed to load service report");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServiceReport();
  }, [serviceId]);

  if (loading) return <LoadingSpinner />;
  if (error) return <p className="text-danger">{error}</p>;
  if (!reportData) return null;

  const {
    services,
    chartimgs,
    totalcount50,
    positivecount50,
    negativecount50,
    totalprofit50,
    totalloss50,
    avgprofit50,
    accuracy50,
    profitvalue50,
    lossvalue50,
    totalcount500,
    positivecount500,
    negativecount500,
    totalprofit500,
    totalloss500,
    avgprofit500,
    accuracy500,
    profitvalue500,
    lossvalue500,
    performance,
    datewise
  } = reportData;

  // Doughnut Chart Data for Last 50 Trades
  const doughnutData50 = {
    labels: ["Profit", "Loss"],
    datasets: [
      {
        data: [profitvalue50, lossvalue50],
        backgroundColor: ["#6fca00", "#e03e25"],
        borderWidth: 0,
      },
    ],
  };

  // Doughnut Chart Data for Last 500 Trades
  const doughnutData500 = {
    labels: ["Profit", "Loss"],
    datasets: [
      {
        data: [profitvalue500, lossvalue500],
        backgroundColor: ["#6fca00", "#e03e25"],
        borderWidth: 0,
      },
    ],
  };

  const downloadChart50 = () => {
    const chartElement = document.getElementById("chart50-container");
    if (!chartElement) return;

    html2canvas(chartElement, {
      scale: 2,
      backgroundColor: "#ffffff",
      useCORS: true
    }).then((canvas) => {
      const ctx = canvas.getContext("2d");

      // Create a larger canvas to accommodate title and disclaimer
      const finalCanvas = document.createElement('canvas');
      finalCanvas.width = canvas.width;
      finalCanvas.height = canvas.height + 160; // Extra space for title and disclaimer
      const finalCtx = finalCanvas.getContext("2d");

      // Fill background
      finalCtx.fillStyle = "#ffffff";
      finalCtx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);

      // Add title
      finalCtx.fillStyle = "#000000";
      finalCtx.font = "bold 36px Arial";
      finalCtx.textAlign = "center";
      finalCtx.fillText("Last 50 Trades Summary", finalCanvas.width / 2, 50);

      // Add main content (original canvas)
      finalCtx.drawImage(canvas, 0, 80);

      // Add disclaimer
      finalCtx.fillStyle = "#666666";
      finalCtx.font = "14px Arial";
      finalCtx.textAlign = "center"; // center align for full width
      const disclaimer = [
        "Disclaimer: The performance data shows the Research Results generated by our recommendations.",
        "Past performance doesn't guarantee future success. Investing in the securities market involves market risks.",
        "The securities mentioned do not constitute a recommendation. The returns displayed are for informational purposes",
        "only and should not be considered advertisements or promotions influencing your subscription decisions."
      ];

      const maxWidth = finalCanvas.width - 80; // leave some padding
      const lineHeight = 18;
      const startY = canvas.height + 80;

      disclaimer.forEach((line, index) => {
        wrapText(finalCtx, line, finalCanvas.width / 2, startY + index * lineHeight, maxWidth, lineHeight);
      });

      // Helper function to wrap text
      function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
        const words = text.split(" ");
        let line = "";
        let lineCount = 0;

        for (let n = 0; n < words.length; n++) {
          const testLine = line + words[n] + " ";
          const metrics = ctx.measureText(testLine);
          const testWidth = metrics.width;
          if (testWidth > maxWidth && n > 0) {
            ctx.fillText(line, x, y + lineCount * lineHeight);
            line = words[n] + " ";
            lineCount++;
          } else {
            line = testLine;
          }
        }
        ctx.fillText(line, x, y + lineCount * lineHeight);
      }

      const link = document.createElement("a");
      link.download = "Last-50-Trades-Summary.png";
      link.href = finalCanvas.toDataURL("image/png");
      link.click();
    });
  };

  const downloadChart500 = () => {
    const chartElement = document.getElementById("chart500-container");
    if (!chartElement) return;

    html2canvas(chartElement, {
      scale: 2,
      backgroundColor: "#ffffff",
      useCORS: true
    }).then((canvas) => {
      const ctx = canvas.getContext("2d");

      // Create a larger canvas to accommodate title and disclaimer
      const finalCanvas = document.createElement('canvas');
      finalCanvas.width = canvas.width;
      finalCanvas.height = canvas.height + 160; // Extra space for title and disclaimer
      const finalCtx = finalCanvas.getContext("2d");

      // Fill background
      finalCtx.fillStyle = "#ffffff";
      finalCtx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);

      // Add title
      finalCtx.fillStyle = "#000000";
      finalCtx.font = "bold 36px Arial";
      finalCtx.textAlign = "center";
      finalCtx.fillText("Last 500 Trades Summary", finalCanvas.width / 2, 50);

      // Add main content (original canvas)
      finalCtx.drawImage(canvas, 0, 80);

      // Add disclaimer (wrapped text)
      finalCtx.fillStyle = "#666666";
      finalCtx.font = "14px Arial";
      finalCtx.textAlign = "center"; // center align for full width
      const disclaimer = [
        "Disclaimer: The performance data shows the Research Results generated by our recommendations.",
        "Past performance doesn't guarantee future success. Investing in the securities market involves market risks.",
        "The securities mentioned do not constitute a recommendation. The returns displayed are for informational purposes",
        "only and should not be considered advertisements or promotions influencing your subscription decisions."
      ];

      const maxWidth = finalCanvas.width - 80; // padding from sides
      const lineHeight = 18;
      const startY = canvas.height + 100;

      disclaimer.forEach((line, index) => {
        wrapText(finalCtx, line, finalCanvas.width / 2, startY + index * lineHeight, maxWidth, lineHeight);
      });

      // Helper function to wrap text
      function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
        const words = text.split(" ");
        let line = "";
        let lineCount = 0;

        for (let n = 0; n < words.length; n++) {
          const testLine = line + words[n] + " ";
          const metrics = ctx.measureText(testLine);
          const testWidth = metrics.width;
          if (testWidth > maxWidth && n > 0) {
            ctx.fillText(line, x, y + lineCount * lineHeight);
            line = words[n] + " ";
            lineCount++;
          } else {
            line = testLine;
          }
        }
        ctx.fillText(line, x, y + lineCount * lineHeight);
      }

      // Download final image
      const link = document.createElement("a");
      link.download = "Last-500-Trades-Summary.png";
      link.href = finalCanvas.toDataURL("image/png");
      link.click();
    });
  };

  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "75%",
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false
      }
    }
  };

  // Performance Chart Data (Last 12 months)
  const performanceChartData = {
    labels: performance.map(p => {
      const date = new Date(p.month);
      return date.toLocaleDateString('en-US', { month: 'short', year: '2-digit' });
    }).reverse(),
    datasets: [
      {
        label: "Last 12 months Performance",
        data: performance.map(p => p.total_gains).reverse(),
        backgroundColor: "#127BBC",
        borderColor: "#127BBC",
        borderWidth: 1.5,
        pointBackgroundColor: "#FFFFFF",
        pointBorderWidth: 1.5,
        pointRadius: 4,
        pointHoverBackgroundColor: "#127BBC",
        pointHoverBorderColor: "#FFFFFF",
        pointHoverRadius: 7,
      }
    ]
  };

  // Recent Trades Chart Data
  const recentTradesData = {
    labels: datewise.map(d => {
      const date = new Date(d.date);
      return date.toLocaleDateString('en-US', { day: '2-digit', month: '2-digit' });
    }).reverse(),
    datasets: [
      {
        label: "Recent Trades Advisories Report",
        data: datewise.map(d => d.total_gains).reverse(),
        backgroundColor: "#127BBC",
        borderColor: "#127BBC",
        borderWidth: 1.5,
        pointBackgroundColor: "#FFFFFF",
        pointBorderWidth: 1.5,
        pointRadius: 4,
        pointHoverBackgroundColor: "#127BBC",
        pointHoverBorderColor: "#FFFFFF",
        pointHoverRadius: 7,
      }
    ]
  };

  const barChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return '₹' + value;
          }
        }
      }
    },
    plugins: {
      legend: {
        display: true,
        position: 'top'
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return 'Gains : ₹' + context.parsed.y;
          }
        }
      }
    }
  };

  // Doughnut with center text component - INCREASED SIZE
  const DoughnutWithCenter = ({ data, profitValue }) => (
    <div style={{ position: 'relative', width: '200px', height: '200px', margin: '0 auto', marginLeft: '0px' }}>
      <Doughnut data={data} options={doughnutOptions} />
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        pointerEvents: 'none'
      }}>
        <div style={{ fontSize: '16px', color: '#9ca3af', fontWeight: '500' }}>Profit</div>
        <div style={{ fontSize: '24px', color: '#3f4b6b', fontWeight: '700', marginTop: '8px' }}>₹{formatNumber(profitValue)}</div>
      </div>
    </div>
  );

  // Accuracy circle component - INCREASED SIZE
  const AccuracyCircle = ({ accuracy }) => {
    const size = 200; // Increased from 140 to 200
    const strokeWidth = 16; // Increased from 12 to 16
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (accuracy / 100) * circumference;

    return (
      <svg width={size} height={size}>
        <circle
          stroke="#e0e0e0"
          fill="transparent"
          strokeWidth={strokeWidth}
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />
        <circle
          stroke="#6fca00"
          fill="transparent"
          strokeWidth={strokeWidth}
          r={radius}
          cx={size / 2}
          cy={size / 2}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 1s' }}
        />
        <text x="50%" y="45%" textAnchor="middle" fontSize="16" fill="#000">Accuracy</text>
        <text x="50%" y="60%" textAnchor="middle" fontSize="28" fontWeight="bold" fill="#000">{accuracy}%</text>
      </svg>
    );
  };

  // Number formatting function for Indian comma notation
  const formatNumber = (value) => {
    if (value === null || value === undefined || value === "") return "0";

    const num = Number(String(value).replace(/[^0-9.-]+/g, ""));
    if (isNaN(num)) return "0";

    // If decimal part is .00 → remove decimals
    if (num % 1 === 0) {
      return num.toLocaleString("en-IN");
    }

    // Otherwise keep 2 decimals
    return num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };


  // Summary Box Component
  const SummaryBox = ({ data }) => {
    const { totalCalls, totalProfit, profitCalls, totalLoss, lossCalls, netProfit } = data;
    return (
      <div className="summarylist">
        <div className="summary-row">
          <div className="summary-item">✓ Total Calls : <span className="blue-text">{totalCalls}</span></div>
          <div className="summary-item">✓ Total Profit : <span className="green-text">₹ {formatNumber(totalProfit)}</span></div>
        </div>
        <div className="summary-row">
          <div className="summary-item">✓ Profitable Calls : <span className="green-text">{profitCalls}</span></div>
          <div className="summary-item">✓ Total Loss : <span className="red-text">₹ {formatNumber(totalLoss)}</span></div>
        </div>
        <div className="summary-row">
          <div className="summary-item">✓ Loss Calls : <span className="red-text">{lossCalls}</span></div>
          <div className="summary-item">✓ Net Profit : <span className="green-text">₹ {formatNumber(netProfit)}</span></div>
        </div>
      </div>
    );
  };

  // Prepare data for summary boxes
  const tradeData50 = {
    totalCalls: totalcount50,
    profitCalls: positivecount50,
    lossCalls: negativecount50,
    totalProfit: totalprofit50,
    totalLoss: totalloss50,
    netProfit: avgprofit50
  };

  const tradeData500 = {
    totalCalls: totalcount500,
    profitCalls: positivecount500,
    lossCalls: negativecount500,
    totalProfit: totalprofit500,
    totalLoss: totalloss500,
    netProfit: avgprofit500
  };

  return (
    <div id="content" className="">
      {/* Page Header */}
      <h1 className="page-header">
        Dashboard <small> Analysis</small>
      </h1>

      <div className="row">
        {/* Recent Report Chart */}
        <div className="col-md-12">
          <div className="panel panel-default with-rounded-corner with-shadow chartbox">
            <div className="panel-heading">
              <h6 className="panel-title">
                Recent Report
                <span style={{ marginLeft: "10px", color: "#127BBC", fontWeight: 600 }}>
                  ({services?.service_name})
                </span>
              </h6>
            </div>
            <div className="panel-body">
              <div className="box">
                <Bar data={recentTradesData} options={barChartOptions} height={550} />
              </div>
            </div>
          </div>
        </div>

        {/* New Design for Last 50 Trades Summary */}
        <div className="col-md-6">
          <div className="panel panel-default with-rounded-corner with-shadow chartbox">
            <div className="panel-heading">
              <h6 className="panel-title">
                Last 50 Trades Summary
                <span className="float-right">
                  <>
                    <a className="genlinkclass" onClick={downloadChart50}>
                      <FontAwesomeIcon icon={faDownload} />
                    </a>

                    <a className="genlinkclass" href={`${API_URL}dashboard/genServiceReport/${serviceId}/50`}>
                      <FontAwesomeIcon icon={faShare} />
                    </a>
                  </>
                </span>
              </h6>
            </div>
            <div className="panel-body">
              <div className="trade-panel-new" id="chart50-container">
                <div className="charts-row">
                  <DoughnutWithCenter data={doughnutData50} profitValue={totalprofit50} />
                  <AccuracyCircle accuracy={accuracy50} />
                </div>
                <SummaryBox data={tradeData50} />
              </div>
            </div>
          </div>
        </div>

        {/* New Design for Last 500 Trades Summary */}
        <div className="col-md-6">
          <div className="panel panel-default with-rounded-corner with-shadow chartbox">
            <div className="panel-heading">
              <h6 className="panel-title">
                Last 500 Trades Summary
                <span className="float-right">
                  <>
                    <a className="genlinkclass" onClick={downloadChart500}>
                      <FontAwesomeIcon icon={faDownload} />
                    </a>
                    <a className="genlinkclass" href={`${API_URL}dashboard/genServiceReport/${serviceId}/500`}>
                      <FontAwesomeIcon icon={faShare} />
                    </a>
                  </>
                </span>
              </h6>
            </div>
            <div className="panel-body">
              <div className="trade-panel-new" id="chart500-container">
                <div className="charts-row">
                  <DoughnutWithCenter data={doughnutData500} profitValue={totalprofit500} />
                  <AccuracyCircle accuracy={accuracy500} />
                </div>
                <SummaryBox data={tradeData500} />
              </div>
            </div>
          </div>
        </div>

        {/* Performance By Services */}
        <div className="col-md-12">
          <div className="panel panel-default with-rounded-corner with-shadow">
            <div className="panel-heading">
              <h4 className="panel-title">Performance By Services</h4>
            </div>
            <div className="panel-body">
              <Bar data={performanceChartData} options={barChartOptions} height={50} />
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .content {
          padding: 20px;
        }
        .page-header {
          margin: 0 0 20px;
          padding: 0;
          border: none;
          font-size: 24px;
        }
        .page-header small {
          color: #6c757d;
          font-size: 16px;
        }
        .panel {
          margin-bottom: 30px;
          background: #fff;
          border: none;
          border-radius: 8px;
        }
        .panel-default.with-rounded-corner.with-shadow {
          border-radius: 8px;
          box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.2);
          border: none;
        }
        .chartbox {
          padding: 20px 15px;
          margin-bottom: 30px;
        }
        .panel-heading {
          background: #fff;
          border-bottom: 1px solid rgba(83, 91, 98, 0.25);
          padding: 15px 20px;
          border-radius: 8px 8px 0 0;
        }
        .panel-title {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
          color: #333;
        }
        .panel-body {
          padding: 20px;
        }
        
        /* New Trade Panel Styles */
        .trade-panel-new {
          text-align: center;
        }
        .charts-row {
          display: flex;
          justify-content: space-around;
          align-items: center;
          margin-bottom: 30px;
        }
        .summarylist {
          text-align: left;
        }
        .summary-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 15px;
        }
        .summary-item {
          font-size: 16px;
          display: flex;
          align-items: center;
        }
        .blue-text {
          color: #127BBC;
          font-weight: 600;
          margin-left: 4px;
        }
        .green-text {
          color: #6fca00;
          font-weight: 600;
          margin-left: 4px;
        }
        .red-text {
          color: #e03e25;
          font-weight: 600;
          margin-left: 4px;
        }

        .genlinkclass {
          padding: 5px 10px;
          font-size: 15px;
          color: #000;
          text-decoration: none !important;
          margin-left: 10px;
          cursor: pointer;
        }
        .genlinkclass:hover {
          color: #127BBC;
        }
        .float-right {
          float: right;
        }
        #chart50-container, #chart500-container {
          background: #ffffff !important;
          padding: 40px;
          border-radius: 12px;
        }

        @media (max-width: 768px) {
          .charts-row {
            flex-direction: column;
            gap: 30px;
          }
          .summary-row {
            flex-direction: column;
            gap: 10px;
          }
          .summary-item {
            justify-content: space-between;
          }
        }
      `}</style>
    </div>
  );
};

export default ServiceReport;